import { render, staticRenderFns } from "./MenuListSkeltonLoader.vue?vue&type=template&id=dc6fe5d6&scoped=true&"
import script from "./MenuListSkeltonLoader.vue?vue&type=script&lang=ts&"
export * from "./MenuListSkeltonLoader.vue?vue&type=script&lang=ts&"
import style0 from "./MenuListSkeltonLoader.vue?vue&type=style&index=0&id=dc6fe5d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6fe5d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VContainer,VItemGroup,VRow,VSkeletonLoader})
